import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../../images/collapse copy 5.png'
import ExpandIcon from '../../../../images/expand copy 5.png'

class BekreftetGrunnbokBestilling extends Component {
    state = {
        isOpened: false
    }

    toggleBestilling = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var bestilling = this.props.bestilling
        var matrikkelnummer = `${bestilling.gardsnummer}/${bestilling.bruksnummer}`;
        if (bestilling.festenummer || bestilling.seksjonsnummer) matrikkelnummer += `/${bestilling.festenummer}/${bestilling.seksjonsnummer}`;

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBestilling}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{t('bekreftetgrunnbok')} {matrikkelnummer}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('gdobrukernavn')}</div>
                            <div className="value">{bestilling.gdoUsername}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bestillingsdato')}</div>
                            <div className="value"><Moment local parse="YYYY-MM-DDTHH:mm:ss">{bestilling.bestillingsDato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('matrikkelnummer')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('fakturareferanse')}</div>
                            <div className="value">{bestilling.fakturareferanse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BekreftetGrunnbokBestilling)